var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[(!_vm.usuarioActual.Loggeado)?_c('v-btn',{attrs:{"x-large":"","color":"success"},on:{"click":_vm.irALogin}},[_vm._v("Iniciar sesión")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }